import React  from 'react'
import GridContainer from '../../components/Grid/GridContainer'
import GridItem from '../../components/Grid/GridItem'
import { Field, reduxForm } from 'redux-form'
import withStyles from '@material-ui/core/styles/withStyles'
import PropTypes from 'prop-types'
import requisitionFormStyle from '../../assets/jss/requisitionFormStyle'
// import YomaEditor from '../../components/YomaEditor'
import { 
    Button, 
    FormControl, 
    InputLabel, 
    Select,
    OutlinedInput,
    MenuItem,
    Checkbox,
    ListItemText,
    Chip
}from '@material-ui/core'
import {
    FORM_REQUISITION,
    BENEFITS
} from '../../utils/CommonConstant'
import {
    renderTextField
} from './RenderComponent'

const AdditionalInformationForm = (props) => {

    const { 
        classes, 
        onChangeLocal, 
        next, 
        back,
        selectedItems,
        pristine,
        submitting,
    } = props

    return (
        // <form className={classes.form} onSubmit={() => next()}>
        <form className={classes.form}>
            <GridContainer>
               
                <GridItem xs={12} sm={12} md={12}>
                    <FormControl fullWidth  variant="outlined" className={classes.select}>
                        <InputLabel htmlFor="local_benefit">
                            Local Benefits
                        </InputLabel>
                        <Select
                            fullWidth
                            multiline
                            onChange={(event) => onChangeLocal(event.target.value)}
                            input={<OutlinedInput id="local_benefit" labelWidth={100}/>}
                            value={""}
                            
                        >
                            {
                                BENEFITS.map( (benefit, key) => (
                                    
                                    <MenuItem key={key} value={benefit}>

                                        <Checkbox checked={selectedItems.indexOf(benefit) > -1 } />
                                        
                                        <ListItemText primary={benefit}/>
                                    </MenuItem>

                                ))
                            }
                        </Select>
                    </FormControl>
                </GridItem>
                {
                    selectedItems.length > 0 && (
                    <GridItem xs={12} sm={12} md={12}>
                        <div className={classes.chips}>
                            {
                                selectedItems.map((benefit, key) => (
                                    <Chip 
                                        key={key} 
                                        label={benefit} 
                                        variant="outlined" 
                                        color="secondary"
                                        onDelete={() => onChangeLocal(benefit)}

                                    />
                                ))
                            }
                        </div>
                    </GridItem>
                    )
                }
                
                <GridItem xs={12} sm={12} md={12}>
                    <Field
                            name="others_benefits"
                            label="Other Benefits"
                            component={renderTextField}
                            style={classes.input}
                        />
                </GridItem>


                <GridItem xs={12} sm={12} md={12}>
                    <label>
                        Please provide additional bebefits or information of what is
                        to be provided for the candidate as part of their trems and 
                        conditionals. 
                    </label>
                </GridItem>
                
                <GridItem xs={12} sm={6} md={6}>
                      <div className="Button-Holder">
                        <Button
                           className={classes.prev_button}
                          variant="contained"
                          onClick={() => back()}>
                          Previous
                        </Button>
                      </div>
                      
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                    <div className="Button-Holder">
                      <Button
                        className={classes.button}
                        disabled={pristine || submitting}
                        onClick={() => next()}
                        variant="contained"
                        color ="secondary"
                        >
                            Next
                        </Button>
                    </div>
                </GridItem>

            </GridContainer>
    </form> 
    )
} 

AdditionalInformationForm.propTypes = {
    classes: PropTypes.object.isRequired
}



export default reduxForm({
    form: FORM_REQUISITION,
    destroyOnUnmount: false,        
    forceUnregisterOnUnmount: true,
})(withStyles(requisitionFormStyle)(AdditionalInformationForm))






















